import {IAuditWithUserInterface} from '../../global/audit.interface';
import {IPageableResponse} from '../../global/pagging.dto';

export interface IGetCategoriesItemDto extends Partial<IAuditWithUserInterface> {
    category_name?: string;
    created_at?: Date;
    id?: number;
    category_id?: number;
    parent_id?: number;
    parent_category?: number;
    sub_category?: IGetCategoriesItemDto[];
    children?: IGetCategoriesItemDto[];
    updated_at?: Date;
    user_id?: number;
    level?: number;
    workspace_id?: number;
}

export interface IGetCategoriesResponseDTO extends IPageableResponse<IGetCategoriesItemDto> {
}

export interface IFlattenedCategories extends IGetCategoriesItemDto{
    is_sub: 0 | 1
}

export enum CategoryShareModeEnum{
    All = 'all', // Templates, documents, and contracts with all categories are shared
    NoCategory = 'no_category', // Templates, documents, and contracts without any selected category are shared
    Selected = 'selected', // Templates, documents, and contracts with categories from the list are shared
}
